import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

type StatusStyle = {
  color: string;
  backgroundColor: string;
  icon: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PaidStatusBadge',
  props: {
    status: null
  },
  setup(__props: any) {

const props = __props as { status: keyof typeof statusStyles }



const statusStyles: Record<string, StatusStyle> = {
  draft: {
    color: '#8c8c8c',
    backgroundColor: '#e8e8e8',
    icon: 'edit',
  },
  ready: {
    color: '#3a87ad',
    backgroundColor: '#d0e9f3',
    icon: 'hourglass_empty',
  },
  billed: {
    color: '#f39c12',
    backgroundColor: '#fde3a7',
    icon: 'receipt',
  },
  paid: {
    color: '#28a745',
    backgroundColor: '#d4edda',
    icon: 'check',
  },
  completed: {
    color: '#28a745',
    backgroundColor: '#d4edda',
    icon: 'check',
  },
  canceled: {
    color: '#c04646',
    backgroundColor: '#f6c9c9',
    icon: 'money_off_csred',
  },
  past_due: {
    color: '#d9534f',
    backgroundColor: '#f2dede',
    icon: 'warning',
  },
};

const statusIcon = computed(() => statusStyles[props.status]?.icon || null);

const badgeStyle = computed(() => {
  const status = statusStyles[props.status];
  return {
    color: status?.color || 'inherit',
    backgroundColor: status?.backgroundColor || 'transparent',
  };
});

const statusTitle = computed((): string => {
  switch (props.status) {
    case 'past_due':
      return 'Past due';
    default:
      return props.status;
  }
});

const iconStyle = computed(() => ({
  color: statusStyles[props.status]?.color || 'inherit',
}));

return { __sfc: true,props, statusStyles, statusIcon, badgeStyle, statusTitle, iconStyle }
}

})